<template>
	<div>
		<v-chart class="chart_sentiment_market_top" :options="line" @datazoom='onDataZoom($event,line)'/>
		<b-alert show variant="light">
			<ul>
				<li>牛市行情：大屁股表现(100+)对应大红和深红,蓝筹抱团为主</li>
				<li>震荡行情：题材表现(50-100),对应蓝色,题材为主</li>
				<li>熊市行情: 市场鲜有表现机会(0-50),对应绿色,观望为主</li>
			</ul>
		</b-alert>
	</div>
</template>

<script>
	import ECharts from 'vue-echarts'
	import axios from 'axios'
	import Moment from 'moment'

	import {
		request_zzquant
	} from "network/request.js"

	const upColor = '#ec0000';
	const upBorderColor = '#8A0000';
	// const downColor = '#00da3c';
	// const downBorderColor = '#008F28';

	export default {
		props: {
			title: {
				type: String,
				default: "市场结构周期"
			},
			subText: {
				type: String,
				default: "年度大周期"
			},
			zoom_start: {
				type: [Number, String],
				default: 70,
			},
			zoom_end: {
				type: Number,
				default: 100,
			}
		},
		mounted() {
			this.refresh();
		},
		components: {
			'v-chart': ECharts
		},
		data() {
			return {
				line: {
					title: {
						text: this.title,
						subtext: this.subText,
						left: 0,
						textStyle: {
							color: '#999999'
						},
						subtextStyle: {
							color: '#666666'
						}
					},
					legend: {
						data: ['市场得分','MA10'],
						textStyle: {
							color: '#999999'
						},
					},
					grid: [{
						left: '5%',
						right: '5%',
						// height: '75%'
					}],
					xAxis: [{
						type: 'category',
						scale: true,
						boundaryGap: false,
						axisLine: {
							onZero: false,
							lineStyle: {
								color: '#666666'
							}
						},
						splitLine: {
							show: false
						},
						splitNumber: 10,
						min: 'dataMin',
						max: 'dataMax',
						axisPointer: {
							z: 100
						},
						axisLabel: {
							fontSize: 10,
							color: '#999999'
						},
					}],
					yAxis: [{
						name: "分数",
						scale: true,
						position: 'right',
						min: 0,
						max: 'dataMax',
						splitNumber: 10,
						splitLine: {
							show: false
						},
						splitArea: {
							show: false
						},
						axisLabel: {
							interval: 0,
							formatter: '{value}',
							color: '#999999'
						},
						lineStyle: {
							normal: {
								width: 1,
								opacity: 0.6,
								color: upBorderColor
							}
						},
						axisLine: {
							lineStyle: {
								color: '#666666'
							}
						},
						nameTextStyle: {
							color: '#999999'
						}
					}, ],
					visualMap: {
						// top: 10,
						// right: 10,
						type: 'piecewise',
						show: false,
						seriesIndex: 0,
						dimension: 1,
						pieces: [{
								min: parseFloat(200),
								color: upBorderColor
							},
							{
								min: parseFloat(100),
								max: parseFloat(200),
								color: upColor
							},
							{
								min: parseFloat(50),
								max: parseFloat(100),
								color: "#6667de"
							},
							{
								min: parseFloat(0),
								max: parseFloat(50),
								color: "#cac500"
							},
						],
						outOfRange: {
							symbol: 'rect',
							symbolSize: [1, 1],
							color: upBorderColor,
						}
					},
					dataZoom: [{
						show: true,
						type: 'slider',
						xAxisIndex: [0],
						y: '90%',
						start: this.zoom_start,
						end: this.zoom_end,
						textStyle: {
							color: '#999999'
						}
					}],
					series: [],
					tooltip: {
						trigger: 'axis',
					}
				}
			}
		},
		methods: {
			calculateMA(dayCount, data) {
				var result = [];
				for (var i = 0, len = data.length; i < len; i++) {
					if (i < dayCount) {
						result.push('-');
						continue;
					}
					var sum = 0;
					for (var j = 0; j < dayCount; j++) {
						sum += data[i - j];
					}
					result.push(+(sum / dayCount).toFixed(2));
				}
				return result;
			},
			onDataZoom(event,option){
				if(event.type == 'datazoom'){
					let last_end = event.end
					if(event.start == 0){
						let data_start = option.xAxis[0].data[0]
						let data_start_year = Moment(data_start).year()
						if(data_start_year<=2014){
							return
						}
						let data_start_new = (data_start_year-1)+'-01-01'
						this.line.dataZoom[0].start=5
						this.line.dataZoom[0].end=last_end
						this.refresh(data_start_new)
					}
					
				}
				// console.log(option)
			},
			refresh(data_start) {
				let url = '/v3/api/timing/market/style?date1='
				if(data_start){
					url += data_start
				}else{
					url += (Moment().year()-2)+'-01-01'
				}
				axios.all([
						request_zzquant({
							'url': url
						}),
					])
					.then(axios.spread((resp1) => {
						let splitDataItem = this.splitData(resp1['data']['data']);
						let series_data = []
						// console.log(splitDataItem.timings);
						series_data.push({
							name: '市场得分',
							data: splitDataItem.scores,
							type: 'bar',
							markLine: {
								symbol:'none',//去掉箭头
								data: [{
										type: 'average',
										name: '均值',
										symbol: 'circle',
									},
									{
										lineStyle: { //警戒线的样式  ，虚实  颜色
											type: "dotted",
											color: upBorderColor,
										},
										label: {
											position: 'end',
											formatter: "牛市(100)"
										},
										yAxis: 100
									},
								]
							},
							markArea: {
									itemStyle: {
										color: 'rgba(255, 173, 177, 0.4)'
									},
									data: splitDataItem.timing_area_data
								}
						});
						
						series_data.push({
							name: 'MA10',
							data: this.calculateMA(10, splitDataItem.scores),
							type: 'line',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.6
								}
							},
							symbol: 'circle',
						});

						this.line['xAxis'] = [{
							type: 'category',
							data: splitDataItem.categoryData
						}]
						this.line['series'] = series_data;
						this.line.legend.data = ['市场得分','MA10'];
					}))
					.catch(err => {
						console.log(err);
					})
			},
			splitData(rawData) {
				let [categoryData, scores, scores2, timings,timing_area_data] = [
					[],
					[],
					[],
					[],
					[]
				];
				//解构赋值
				let area_item = []
				rawData.forEach(item => {
					var item_date = item['date']
					categoryData.push(item_date);
					var score = item['score']
					var score2 = item['score2']
					var timing = item['timing']
					if (score > 600) {
						score = 600
					}
					if (score2 > 600) {
						score2 = 600
					}
					scores.push(score);
					scores2.push(score2);
					// 区域划分，N个区域，从第一个-1开始
					if(area_item.length==0){
						if(timing == -1){
							area_item.push(item_date);
						}
					}else{
						if(timing == 0){
							area_item.push(item_date);
							timings.push(area_item)
							area_item = []
						}else{
							//补漏,截止最后的数据未配对成功
							if(item_date == rawData[rawData.length-1]['date']){
								area_item.push(item_date);
								timings.push(area_item)
								area_item = []
							}
						}
					}
				})
				
				timings.forEach(item=>{
					timing_area_data.push([{xAxis:item[0]},{xAxis:item[1]}])
				})
				return {
					categoryData: categoryData,
					scores: scores,
					scores2: scores2,
					timings: timings,
					timing_area_data:timing_area_data
				};
			},
			// 最后在beforeDestroy()生命周期内清除定时器：
			beforeDestroy() {

			}
		}
	}
</script>

<style scoped>
	.chart_sentiment_market_top {
		width: 100%;
		height: 400px;
	}
</style>
